import {
  requestConfirmGlobalInbound as postConfirmGlobalInbound,
  requestGlobalInboundRollback as postGlobalInboundRollback,
} from '@/console/api/globalInboundRollback'
import { ConfirmGlobalInboundRequest, GlobalInboundRollbackRequest, GlobalInboundRollbackResponse } from '@/console/api/types'

/** 글로벌 입고확정 롤백 · 재확정. `api/globalInboundRollback.ts` 로 그대로 위임한다 — 재시도를 얹지 않는다. */
export const requestGlobalInboundRollback = (request: GlobalInboundRollbackRequest): Promise<GlobalInboundRollbackResponse> =>
  postGlobalInboundRollback(request)

export const requestConfirmGlobalInbound = (request: ConfirmGlobalInboundRequest): Promise<number[]> => postConfirmGlobalInbound(request)
